<template>
  <div class="wrapper">
    <div class="container">
      <div class="img">
        <img src="../../assets/imgs/pay-success@3x.png" alt />
      </div>
      <h4>
        账户注销成功
        <small>此账户已被注销成功，如需使用智云医道服务，请重新注册</small>
      </h4>
      <div class="btn">
        <van-button style="width: 100%" round type="primary" @click="closeWindow">确定</van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    closeWindow() {
      window.wx.closeWindow();
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  text-align: center;
  height: 100%;
  background: #ffffff;
  .container {
    padding: 40px 30px;
    background-color: #fff;
    min-height: 243px;
    > h4 {
      font-size: 18px;
      margin: 0;
      margin-bottom: 20px;
      small {
        display: block;
        color: #999;
        padding-top: 10px;
        font-size: 14px;
        text-align: left;
        line-height: 20px;
      }
    }
    > p {
      color: #666;
      margin-bottom: 24px;
    }
  }
  .btn {
    text-align: center;
    button:nth-child(1) {
      margin-right: 12px;
    }
  }
}
.img {
  width: 44px;
  margin: 0 auto 20px;

  > img {
    width: 100%;
  }
}
</style>
